import { apiFetch } from "./client";

export type MarketView = {
  id: string;
  name: string;
  description: string | null;
  countryCodes: string[];
};

export type MarketRequest = {
  name: string;
  description?: string | null;
  countryCodes: string[];
};

export type SalesScopeType = "MARKET" | "COUNTRY";

export type UserSalesScopeView = {
  id: string;
  scopeType: SalesScopeType;
  marketId: string | null;
  marketName: string | null;
  countryCode: string | null;
};

export const marketsApi = {
  list:    () => apiFetch<MarketView[]>("/admin/markets"),
  // Lightweight {id,name} list from the markets:view overview (director/admin).
  overviewList: () => apiFetch<{ id: string; name: string }[]>("/markets/overview"),
  get:     (id: string) => apiFetch<MarketView>(`/admin/markets/${id}`),
  create:  (body: MarketRequest) => apiFetch<MarketView>("/admin/markets", { method: "POST", body }),
  update:  (id: string, body: MarketRequest) =>
             apiFetch<MarketView>(`/admin/markets/${id}`, { method: "PUT", body }),
  delete:  (id: string) =>
             apiFetch<void>(`/admin/markets/${id}`, { method: "DELETE" }),

  listUserScopes: (userId: string) =>
             apiFetch<UserSalesScopeView[]>(`/admin/users/${userId}/sales-scopes`),
  addUserMarket:  (userId: string, marketId: string) =>
             apiFetch<UserSalesScopeView>(`/admin/users/${userId}/sales-scopes`,
               { method: "POST", body: { scopeType: "MARKET", marketId } }),
  addUserCountry: (userId: string, countryCode: string) =>
             apiFetch<UserSalesScopeView>(`/admin/users/${userId}/sales-scopes`,
               { method: "POST", body: { scopeType: "COUNTRY", countryCode } }),
  removeUserScope: (userId: string, scopeId: string) =>
             apiFetch<void>(`/admin/users/${userId}/sales-scopes/${scopeId}`, { method: "DELETE" }),
};
